/**
 * @jsxRuntime classic
 * @jsx jsx
 */
/** @jsxFrag */
import React from 'react';

// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import { css, jsx } from '@emotion/react';
import { ReactRenderer } from '@atlaskit/renderer';
import { RendererActionsContext } from '@atlaskit/renderer/actions';
import { editorExperiment } from '@atlaskit/tmp-editor-statsig/experiments';
var rendererContainerStyles = css({
  overflow: 'hidden',
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
  '.ak-renderer-document': {
    // We add 4px to avoid smart link bottom borders being visually clipped on the first line
    maxHeight: "calc(".concat("var(--ds-space-250, 20px)", " + ", "var(--ds-space-050, 4px)", ")"),
    marginRight: "var(--ds-space-100, 8px)",
    flexGrow: 1,
    flexShrink: 1,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    p: {
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
      hyphens: 'auto',
      wordWrap: 'break-word'
    },
    // This is a workaround for when the renderer has multiple paragraphs
    // which can be achieved by pasting in the input field. This will add
    // an ellipsis to the first paragraph.
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
    'p:not(:only-child)::after': {
      content: '"..."'
    },
    // The content can have multiple lines separated by <br> tags if the user
    // does shift+enter in the input field. This wraps the content onto one
    // line to allow the parent element to add the ellipsis.
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors, @atlaskit/ui-styling-standard/no-nested-selectors
    'p br': {
      content: '""',
      '&::after': {
        content: '" "'
      }
    },
    // Override smart links line original line wrapping behaviour to allow our
    // truncation CSS logic to trigger when part of multilined prompt content.
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    'span[data-inline-card] [data-testid="inline-card-icon-and-title"]': {
      whiteSpace: 'nowrap'
    }
  }
});
var RendererWrapper = function RendererWrapper(_ref) {
  var children = _ref.children;
  if (!editorExperiment('platform_editor_ai_command_palate_improvement', 'test')) {
    return jsx(React.Fragment, null, children);
  }
  return jsx("div", {
    css: rendererContainerStyles
  }, children);
};
export var LatestPromptRenderer = function LatestPromptRenderer(_ref2) {
  var promptADF = _ref2.promptADF,
    providerFactory = _ref2.providerFactory;
  var jsonDocument = promptADF;
  return jsx(RendererActionsContext, null, jsx(RendererWrapper, null, jsx(ReactRenderer, {
    document: jsonDocument,
    media: {
      // We don't currently support images with captions
      allowLinking: false
    }
    // By default -- the renderer uses a "default schema" which supports all
    // the nodes and marks the markdown transformer can create.
    // see packages/editor/adf-schema/src/schema/default-schema.ts for details.
    ,
    useSpecBasedValidator: true,
    dataProviders: providerFactory,
    maxHeight: 20
  })));
};